import { ConfigProvider as DspConfigProvider } from '@ad/kcfe-asset-dsp';
import { ConfigProvider, Select } from 'm-ui';
import { Locale } from 'm-ui/lib/locale-provider';
import 'moment/locale/zh-cn';
import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { IntlConfig, IntlProvider } from 'react-intl';
import { LanguageType } from 'types/enum';
import enUS from './language/en-US.json';
import zhCN from './language/zh-CN.json';
import MUII18N from './m-ui';

const localeInfo = {
    [LanguageType.zhCN]: zhCN, // 一期应该暂时不需要动态加载
    [LanguageType.enUS]: enUS,
};

export type LocaleInfoKey = Keys<typeof localeInfo>;

const I18NContext = React.createContext({
    /** 当前语言 */
    locale: LanguageType.enUS,
    /** 设置显示的语言 */
    setLocale: (value: LocaleInfoKey) => {},
});

type Keys<T> = keyof T;

/**
 * 使用上下locale的context
 */
export function useLocale() {
    return React.useContext(I18NContext);
}

export const storageLocaleValue = (localStorage.getItem('locale') as LanguageType) ?? LanguageType.enUS;

interface II18NProps extends Omit<IntlConfig, 'locale' | 'messages'> {}

export const I18N: React.FC<II18NProps> = (props) => {
    const [locale] = useState<LocaleInfoKey>(storageLocaleValue);
    const [muiLocale, setMuiLocale] = useState<Locale>();

    const setLocale = React.useCallback((value) => {
        localStorage.setItem('locale', value);
        window.location.reload();
        // setLocaleValue(value);
    }, []);

    React.useEffect(() => {
        async function getMUILocal() {
            const importMuiLocale = await MUII18N[locale];
            setMuiLocale(importMuiLocale.default);
        }
        // eslint-disable-next-line no-void
        void getMUILocal();
    }, [locale]);

    return (
        <I18NContext.Provider value={{ locale, setLocale }}>
            {/* react-intl 的 i18n */}
            <IntlProvider defaultLocale="en-US" messages={localeInfo[locale]} locale={locale}>
                {/* dsp 组件的 i18n */}
                <DspConfigProvider locale={locale}>
                    {/* m-ui 的 i18n */}
                    {muiLocale && <ConfigProvider locale={muiLocale}>{props.children}</ConfigProvider>}
                </DspConfigProvider>
            </IntlProvider>
        </I18NContext.Provider>
    );
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function DebugI18N() {
    const { setLocale, locale } = useLocale();
    return ReactDOM.createPortal(
        <div style={{ position: 'fixed', top: '160px', right: '40px', width: '120px' }}>
            <Select
                value={locale}
                onChange={(v) => {
                    setLocale(v as unknown as keyof typeof localeInfo);
                }}
            >
                {Object.keys(localeInfo).map((key) => {
                    return (
                        <Select.Option key={key} value={key}>
                            {key}
                        </Select.Option>
                    );
                })}
            </Select>
        </div>,
        document.body,
    );
}
